import styles from "./container.module.scss";
import React from "react";
export default function Container({
  className = "",
  children,
}: {
  className?: string | undefined;
  children: React.JSX.Element;
}) {
  return (
    <div className={[styles.container, className].join(" ")}>{children}</div>
  );
}
